import React, { useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import { Button } from "reactstrap";
import { FA } from "components/FA";

import { accountService } from "services";

import { Card } from "reactstrap";
import { Login } from "./Login";
import { Register } from "./Register";
import { VerifyEmail } from "./VerifyEmail";
import { DeleteEmail } from "./DeleteEmail";
import { ForgotPassword } from "./ForgotPassword";
import { ResetPassword } from "./ResetPassword";
import { Profile } from "./Profile";

import styles from "./Account.module.css";

function Account({ history, match }) {
  const { path } = match;

  useEffect(() => {
    // redirect to home if already logged in
    if (accountService.userValue) {
      history.push("/");
    }
  }, [history]);

  return (
    <>
      {history.length > 2 && (
        <Button color="link" onClick={history.goBack}>
          <FA icon="angle-left" size="xs" /> back
        </Button>
      )}
      <Card className={styles.card}>
        <Switch>
          <Route path={`${path}/login`} component={Login} />
          <Route path={`${path}/register`} component={Register} />
          <Route path={`${path}/verify-email`} component={VerifyEmail} />
          <Route path={`${path}/delete-email`} component={DeleteEmail} />
          <Route path={`${path}/forgot-password`} component={ForgotPassword} />
          <Route path={`${path}/reset-password`} component={ResetPassword} />
          <Route path={`${path}/profile`} component={Profile} />
          <Redirect to={`${path}/login`} />
        </Switch>
      </Card>
    </>
  );
}

export { Account };
